import { BroadcastStatus } from 'types'
import axios from 'api/axios'

export type GetBroadcastsViewResponse = Array<{
	_id: {
		status: BroadcastStatus
	}
	count: number
}>

export interface GetBroadcastsViewParams {
	client?: string
}

const getBroadcastsView = async (
	params: GetBroadcastsViewParams
): Promise<GetBroadcastsViewResponse> => {
	const response = await axios.get<GetBroadcastsViewResponse>(
		`v1/broadcast/management/insight/view`,
		{
			params,
		}
	)

	return response.data
}

export default getBroadcastsView
